// src/reducers/mainPageReducer.ts
export interface MainPageState {
  selectedProjectId: string | null;
  isGetProjectTriggered: boolean;
  isCreateNewProjectModalOpen: boolean;
  remainingMinutes: number | null;
  isFeedbackDrawerOpen: boolean;
  feedbackProjectId: string;
  feedbackTargetLanguages: string[];
  isDownloading: Record<string, boolean>;
  selectedRows: string[];
  hoveredButton: string | null;
  previewProjectId: string | null;
  isPreviewModalOpen: boolean;
}

export type MainPageAction =
  | { type: "SET_SELECTED_PROJECT_ID"; payload: string | null }
  | { type: "SET_GET_PROJECT_TRIGGERED"; payload: boolean }
  | { type: "SET_CREATE_PROJECT_MODAL"; payload: boolean }
  | { type: "SET_REMAINING_MINUTES"; payload: number | null }
  | { type: "SET_SHOW_FEEDBACK_DRAWER"; payload: boolean }
  | { type: "SET_FEEDBACK_PROJECT_ID"; payload: string }
  | { type: "SET_FEEDBACK_TARGET_LANGUAGES"; payload: string[] }
  | { type: "SET_IS_DOWNLOADING"; payload: Record<string, boolean> }
  | { type: "UPDATE_IS_DOWNLOADING"; key: string; value: boolean }
  | { type: "SET_SELECTED_ROWS"; payload: string[] }
  | { type: "SET_HOVERED_BUTTON"; payload: string | null }
  | { type: "SET_PREVIEW_PROJECT_ID"; payload: string | null }
  | { type: "SET_PREVIEW_MODAL"; payload: boolean };

export const initialMainPageState: MainPageState = {
  selectedProjectId: null,
  isGetProjectTriggered: false,
  isCreateNewProjectModalOpen: false,
  remainingMinutes: null,
  isFeedbackDrawerOpen: false,
  feedbackProjectId: "",
  feedbackTargetLanguages: [],
  isDownloading: {},
  selectedRows: [],
  hoveredButton: null,
  previewProjectId: null,
  isPreviewModalOpen: false,
};

export function mainPageReducer(
  state: MainPageState,
  action: MainPageAction
): MainPageState {
  switch (action.type) {
    case "SET_SELECTED_PROJECT_ID":
      return {...state, selectedProjectId: action.payload};
    case "SET_GET_PROJECT_TRIGGERED":
      return {...state, isGetProjectTriggered: action.payload};
    case "SET_CREATE_PROJECT_MODAL":
      return {...state, isCreateNewProjectModalOpen: action.payload};
    case "SET_REMAINING_MINUTES":
      return {...state, remainingMinutes: action.payload};
    case "SET_SHOW_FEEDBACK_DRAWER":
      return {...state, isFeedbackDrawerOpen: action.payload};
    case "SET_FEEDBACK_PROJECT_ID":
      return {...state, feedbackProjectId: action.payload};
    case "SET_FEEDBACK_TARGET_LANGUAGES":
      return {...state, feedbackTargetLanguages: action.payload};
    case "SET_IS_DOWNLOADING":
      return {...state, isDownloading: action.payload};
    case "UPDATE_IS_DOWNLOADING":
      return {
        ...state,
        isDownloading: {...state.isDownloading, [action.key]: action.value},
      };
    case "SET_SELECTED_ROWS":
      return {...state, selectedRows: action.payload};
    case "SET_HOVERED_BUTTON":
      return {...state, hoveredButton: action.payload};
    case "SET_PREVIEW_PROJECT_ID":
      return {...state, previewProjectId: action.payload};
    case "SET_PREVIEW_MODAL":
      return {...state, isPreviewModalOpen: action.payload};
    default:
      return state;
  }
}